const mutations = {
  setWishlist(state, value) {
    state.wishlist = value;
  },
  addWishlistItem(state, value) {
    state.wishlist.push(value);
  },
  removeWishlistItem(state, value) {
    const index = state.wishlist.indexOf(value);
    state.wishlist.splice(index, 1);
  }
};

export default mutations;
